import * as React from 'react';

export interface IReport {
  active: boolean;
  name: string;
  url: string;
  callback: any;
}

/**
 *
 * EcommContentTemplate1View component
 * @extends {React.PureComponent<IReport>}
 */
export class Navi extends React.PureComponent<IReport> {
  public render(): JSX.Element | null {
    const NaviStyle = this.props.active ? 'active' : '';
  
    return (
      <div className='ecomm-navi'>
        <button className={NaviStyle} onClick={() => this.props.callback(this.props.url)}>{this.props.name}</button>
      </div>
    );
  }
}

export default Navi;